export enum ProductStatusEnum {
    new = 'new',
    wait_generate = 'wait-generate',
    generated = 'generated',
    wait_to_publish = 'wait-to-publish',
    published = 'published',
}
